import { render, staticRenderFns } from "./ReporteVentaList.vue?vue&type=template&id=36a20281&scoped=true&"
import script from "./ReporteVentaList.vue?vue&type=script&lang=js&"
export * from "./ReporteVentaList.vue?vue&type=script&lang=js&"
import style0 from "./ReporteVentaList.vue?vue&type=style&index=0&id=36a20281&lang=scss&scoped=true&"
import style1 from "./ReporteVentaList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ReporteVentaList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a20281",
  null
  
)

export default component.exports